import React from 'react';
import { connect, getIn, useFormikContext, FormikValues } from 'formik';
import { IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { TextField as MuiTextField } from '@ccm-office/ccm-ui';
const TextField = connect(
  ({
    type,
    name,
    label,
    disabled,
    formik: { clearController, values, errors, touched, handleChange, handleBlur, ...formik },
    InputProps,
    helperText,
    clearIconLeftPosition,
    ccmCustomizedTextField,
    ccmCustomizedClean,
    placeholder,
    onChange,
    ...props
  }: any) => {
    const { setFieldValue } = useFormikContext<FormikValues>();

    const getValueIn = () => {
      const temp = getIn(values, name);
      if (temp) return temp;

      const tempNumber = Number(temp);
      if (!isNaN(tempNumber) && temp !== null) return temp;

      return '';
    };

    const OnCancel = () => {
      setFieldValue(name, '');
    };

    const value = getValueIn();
    const error = getIn(errors, name);
    const touch = getIn(touched, name);

    const iProps = Object.assign(
      {
        endAdornment: (
          <React.Fragment>
            {value !== '' && !disabled && (
              <IconButton onClick={ccmCustomizedClean ? ccmCustomizedClean : OnCancel}>
                <ClearIcon
                  style={{
                    position: 'absolute',
                    height: 20,
                    width: 20,
                    left: clearIconLeftPosition || 'unset',
                  }}
                />
              </IconButton>
            )}
          </React.Fragment>
        ),
      },
      InputProps
    );

    if (props.view) {
      return <span>{props.value}</span>;
    }

    return (
      <MuiTextField
        name={name}
        label={label}
        type={type}
        variant="outlined"
        disabled={disabled}
        value={value}
        onChange={(e) => {
          handleChange(e);
          onChange && onChange(e);
        }}
        onBlur={handleBlur}
        InputProps={iProps}
        error={Boolean(touch && error)}
        helperText={(touch && error && error) || helperText}
        placeholder={placeholder}
        {...props}
      />
    );
  }
);

export default TextField;
